import React, {useEffect, useState} from "react";
import {IFornecedoresFilterDto} from "@models/fornecedores/dto.ts";
import {Button, Grid, TextField} from "@mui/material";
import {IFornecedor} from "@models/fornecedores/fornecedor.ts";
import {_fornecedor_endpoints} from "@components/fornecedores/endpoints/_fornecedor_endpoints.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {CpfCnpjInput} from "@shared/custom/CpfCnpjInput.tsx";
import {useApi} from "@contexts/hooks/api/useApi.ts";

export const FornecedorConsultaPage: React.FC = () => {
	const {Get} = useApi();
	const [filters, setFilters] = useState<IFornecedoresFilterDto>({});
	const [pagination, setPagination] = useState<IPagination>({
		page: 1,
		pageSize: 10,
		total: 0,
	});
	
	
	const [fornecedores, setFornecedores] = useState<IFornecedor[]>();
	
	// const [loading, setLoading] = useState(false);
	
	const procuraFornecedorHandler = () => {
		// setLoading(true);
		Get(_fornecedor_endpoints.GetFornecedores(filters, pagination)).then(x => {
			setFornecedores(x.items);
			// setLoading(false);
		});
	};
	
	useEffect(() => {
		if (pagination.page == 0) {
			setPagination({...pagination, page: 1});
			return;
		}
		
		procuraFornecedorHandler();
		
	}, [pagination.page]);
	
	const changeCpfCnpjHandler = (value: string) => {
		setFilters(prevFilters => ({
			...prevFilters,
			CpfCnpj: value,
		}));
	};
	
	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			setPagination(prevPagination => ({...prevPagination, page: 0}));
		}
		if ((e.key.length == 1 || e.key == 'Backspace') && filters.CpfCnpj && filters.CpfCnpj.length == 14) {
			const newValue = filters.CpfCnpj + e.key;
			setFilters(prevFilters => ({
				...prevFilters,
				CpfCnpj: newValue,
			}));
		}
	};
	
	
	return (
		<Grid>
			<Grid container>
				<Grid>
					<CpfCnpjInput
						value={filters.CpfCnpj ?? ''}
						onChange={changeCpfCnpjHandler}
						onKeyDown={handleKeyDown}
					/>
				
				</Grid>
				<Grid>
					<TextField value={filters.Nome ?? ''}
					           onChange={(e) => {
						           setFilters({
							           ...filters,
							           Nome: e.target.value,
						           });
					           }}/>
				</Grid>
				<Grid>
					<Button sx={{height: '100%'}}
					        variant={'outlined'} onClick={() => {
						setPagination({...pagination, page: 0});
					}}>Pesquisar</Button>
				</Grid>
			</Grid>
			<Grid container>
				{fornecedores?.map((fornecedor) => (
					<Grid size={12}>
						<Grid>{fornecedor.id} {fornecedor.nome} - {fornecedor.cpfCnpj}</Grid>
					</Grid>
				))}
			</Grid>
		</Grid>
	);
};